function initAsoSwiper() {
  if (document.querySelector('.aso-swiper.swiper-initialized')) return;

  new Swiper('.aso-swiper', {
    spaceBetween: 16,
    slidesPerView: 'auto',
    centeredSlides: false,
    slideToClickedSlide: true,
    simulateTouch: true, 
    grabCursor: true, 
    touchReleaseOnEdges: true, 
    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
      releaseOnEdges: true
    }, 

    navigation: {
      nextEl: '.aso-next',
      prevEl: '.aso-prev',
    },
  });
}

document.addEventListener('DOMContentLoaded', initAsoSwiper);

document.addEventListener('shopify:section:load', initAsoSwiper);
document.addEventListener('shopify:section:reorder', initAsoSwiper);
document.addEventListener('shopify:section:select', initAsoSwiper);
document.addEventListener('shopify:section:deselect', initAsoSwiper);
